import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import quicksightConfig from '@/config/quicksight.config';
import { colors } from '@/styles/css/colors';

/** Maps each base dashboard to its Daily/Weekly counterpart + toggle label. */
const TOGGLE_CONFIGS = [
  {
    baseId: quicksightConfig.dashboards.digital,
    dwdId: quicksightConfig.dashboards.dwd,
    label: ['Daily / Weekly', 'Digital Report'],
  },
  {
    baseId: quicksightConfig.dashboards.offer,
    dwdId: quicksightConfig.dashboards.dwdOffer,
    label: ['Daily / Weekly', 'Offer Report'],
  },
];

const DailyWeeklyToggle: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentDashboardId = location.pathname.substring(1) || quicksightConfig.defaultDashboardId;

  // Find the toggle config whose base or DWD dashboard matches the current tab.
  // No match (e.g. Store dashboard) means the toggle should be hidden entirely.
  const activeConfig = TOGGLE_CONFIGS.find(
    (config) => config.baseId && (currentDashboardId === config.baseId || currentDashboardId === config.dwdId)
  );

  if (!activeConfig?.dwdId) return null;

  const isDwdActive = currentDashboardId === activeConfig.dwdId;

  return (
    <FormControlLabel
      labelPlacement="start"
      control={
        <Switch
          checked={isDwdActive}
          onChange={isDwdActive
            ? () => navigate(`/${activeConfig.baseId}`)
            : () => navigate(`/${activeConfig.dwdId}`)
          }
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': { color: colors.PRIMARY },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: colors.PRIMARY },
          }}
        />
      }
      label={
        <span style={{
          fontFamily: 'speedee, Arial, sans-serif',
          fontSize: '12px',
          fontWeight: isDwdActive ? 700 : 400,
          color: 'rgb(30, 30, 30)',
          display: 'flex',
          flexDirection: 'column',
          lineHeight: 1.2,
        }}>
          {activeConfig.label.map((line, index) => (
            <span key={index}>{line}</span>
          ))}
        </span>
      }
      sx={{ margin: 0 }}
    />
  );
};

export default DailyWeeklyToggle;
